import React, { FC, ReactNode } from 'react';
import styled from '@emotion/styled';
import { ChartPopover } from './tooltip/ChartPopover';
import { MAX_VALUE_AXIS_WIDTH } from './helpers/config';

const GraphLayoutTimeAxis = styled.svg`
  -ms-grid-column: 5;
  grid-column: 5;
  -ms-grid-row: 4;
  grid-row: 4;
`;

const GraphLayoutDateAxis = styled.svg`
  -ms-grid-column: 5;
  grid-column: 5;
  -ms-grid-row: 5;
  grid-row: 5;
`;

const GraphLayoutGrid = styled.div`
  display: -ms-grid;
  display: grid;
  overflow-wrap: normal;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.1) 0 1px 2px;
  grid-template-columns: ${`
    minmax(0.5rem, auto)
    0.25rem
    auto
    0.25rem
    1fr
    0.25rem
    auto
    0.25rem
    minmax(0.5rem, auto)
  `};
  -ms-grid-columns: ${`
    0.5rem
    0.25rem
    ${MAX_VALUE_AXIS_WIDTH}px
    0.25rem
    1fr
    0.25rem
    1rem
    ${MAX_VALUE_AXIS_WIDTH}px
    0.5rem
  `};
  grid-template-rows: auto auto 1fr 10px 10px auto;
  -ms-grid-rows: auto auto 1fr 10px 10px auto;
  border-bottom: 2px solid #f5f6fb;
  padding-bottom: 1rem;
  width: 100%;
`;

const GraphLayoutGraph = styled.div`
  -ms-grid-column: 5;
  grid-column: 5;
  -ms-grid-row: 3;
  grid-row: 3;
  /* width: 100%; */
  max-width: 100%;
  position: relative;
`;

const GraphLayoutLeftLabel = styled.div`
  position: relative;
  -ms-grid-column: 1;
  grid-column: 1;
  -ms-grid-row: 3;
  grid-row: 3;
  display: flex;
  width: 3.25rem;
  justify-content: center;
  align-items: center;
`;

const GraphLayoutLeftLabelText = styled.div`
  position: absolute;
  display: block;
  font-size: 1.25rem;
  line-height: 1;
  text-align: center;
  width: 150px;
  transform: translate(0.75rem) rotate(270deg);
  -ms-transform: translate(-4.75rem) rotate(270deg);
  margin: 0;
`;
const GraphLayoutBottomLabel = styled.div`
  -ms-grid-column: 5;
  grid-column: 5;
  position: relative;
  -ms-grid-row: 6;
  grid-row: 6;
`;
const GraphLayoutHeader = styled.div`
  padding-top: 1rem;
  padding-bottom: 0.75rem;
  padding-left: 1.5rem;
  grid-column-start: 1;
  grid-column-end: 6;
  -ms-grid-row: 1;
  -ms-grid-column: 1;
  -ms-grid-column-span: 5;
  grid-row: 1;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;
const GraphLayoutHeaderText = styled.h4`
  color: rgba(86, 96, 114, 1);
  font-weight: normal;
  letter-spacing: 0.2px;
  margin: 0;
  font-size: 1.25rem;
  display: inline-flex;
  align-items: center;
`;
const GraphLayoutLeftAxis = styled.svg`
  -ms-grid-column: 3;
  grid-column: 3;
  -ms-grid-row: 3;
  grid-row: 3;
  vertical-align: middle;
  & text {
    text-anchor: end;
    dominant-baseline: middle;
  }
`;
const GraphLayoutRightAxis = styled.svg`
  -ms-grid-column: 7;
  grid-column: 7;
  -ms-grid-row: 3;
  grid-row: 3;
  vertical-align: middle;
  & text {
    text-anchor: start;
    dominant-baseline: middle;
  }
`;

const GraphLayoutHeaderLegend = styled.div`
  margin: 0;
  display: flex;
  align-items: center;
`;

const TitleMessage = styled.span`
  margin: 0 0 0 0.7rem;
  color: #566072;
  font-weight: 400;
  font-size: 0.9rem;
`;

interface ChartPanelProps {
  title: ReactNode;
  titleMessage?: ReactNode;
  popoverText?: ReactNode;
  legend?: ReactNode;
  bottom?: ReactNode;
  leftAxisLabel?: string;
}

const ChartPanel: FC<ChartPanelProps> = props => {
  return (
    <GraphLayoutGrid>
      {props.children}

      <GraphLayoutHeader>
        <GraphLayoutHeaderText>
          {props.title} {props.popoverText && <ChartPopover>{props.popoverText}</ChartPopover>}
          {props.titleMessage && <TitleMessage>{props.titleMessage}</TitleMessage>}
        </GraphLayoutHeaderText>
        {props.legend && <GraphLayoutHeaderLegend>{props.legend}</GraphLayoutHeaderLegend>}
      </GraphLayoutHeader>
      {props.leftAxisLabel && (
        <GraphLayoutLeftLabel>
          <GraphLayoutLeftLabelText>{props.leftAxisLabel}</GraphLayoutLeftLabelText>
        </GraphLayoutLeftLabel>
      )}

      {props.bottom && <GraphLayoutBottomLabel>{props.bottom}</GraphLayoutBottomLabel>}
    </GraphLayoutGrid>
  );
};

export {
  ChartPanel,
  GraphLayoutGraph,
  GraphLayoutGrid,
  GraphLayoutHeader,
  GraphLayoutHeaderLegend,
  GraphLayoutHeaderText,
  GraphLayoutLeftLabel,
  GraphLayoutLeftLabelText,
  GraphLayoutBottomLabel,
  GraphLayoutLeftAxis,
  GraphLayoutRightAxis,
  GraphLayoutDateAxis,
  GraphLayoutTimeAxis,
};
